import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = { ...getInitialState.list() };

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.USER_LOCATIONS_GET_SUCCESS: {
            const { userLocations } = action.payload;
            return helpers.getListReducer(state, userLocations);
        }
        case actionTypes.USER_LOCATIONS_POST_SUCCESS: {
            const { userLocations } = action.payload;
            return helpers.mergeListReducer(state, userLocations);
        }
        default: {
            return state;
        }
    }
}
